import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { Link as LinkScroll, animateScroll } from "react-scroll";
import IconButton from "@material-ui/core/IconButton";
import TwitterIcon from "@material-ui/icons/Twitter";
import Tooltip from "@material-ui/core/Tooltip";
import { Icon } from "@iconify/react";
import TelegramIcon from "@material-ui/icons/Telegram";
import Hidden from "@material-ui/core/Hidden";
import mediumIcon from "@iconify-icons/mdi/medium";
import Modal from "@material-ui/core/Modal";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LinearProgress from "@material-ui/core/LinearProgress";
import Chip from "@material-ui/core/Chip";
import Slide from "@material-ui/core/Slide";
import { useTranslation } from "react-i18next";
import TabSlides from "./signIn/TabSlides";
import LanguageSelector from "./component/LanguageSelector";

import "./signInAnimation.css";
import "./styles/bounceEffect.css";
import "./styles/idoGradient.css";
import "./styles/backgroundGradient.css";
import "./styles/dotNav.css";

const useStyles = makeStyles((theme) => ({
  image2: {
    backgroundImage: `url(/imgs/htgBull.svg)`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "contain",
    backgroundPosition: "center",
    width: "50%",
  },
  image3: {
    backgroundImage: `url(/imgs/htgMare.svg)`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "contain",
    backgroundPosition: "center",
    width: "50%",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ProgressPage = () => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const computeProgress = () => {
      // The scrollTop gives length of window that has been scrolled
      const scrolled = document.documentElement.scrollTop;
      // scrollHeight gives total length of the window and
      // The clientHeight gives the length of viewport
      const scrollLength =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const _progress = `${(100 * scrolled) / scrollLength}`;
      setProgress(Number(_progress));
    };

    // Adding event listener on mounting
    window.addEventListener("scroll", computeProgress);

    // Removing event listener upon unmounting
    return () => window.removeEventListener("scroll", computeProgress);
  });

  return (
    <>
      <Hidden smUp>
        {progress < 80 ? (
          <Slide
            direction="down"
            in
            style={{
              position: "fixed",
              bottom: `60px`,
              right: `20px`,
              zIndex: 2000,
            }}
          >
            <Chip
              label="LOGIN"
              clickable
              color="primary"
              icon={<ExpandMoreIcon />}
              onClick={() => {
                animateScroll.scrollToBottom();
              }}
            />
          </Slide>
        ) : (
          ""
        )}
      </Hidden>
      <LinearProgress
        aria-label="scroll progress"
        variant="determinate"
        value={progress}
        style={{
          position: "fixed",
          top: 0,
          width: "100vw",
          zIndex: 2000,
        }}
      />
    </>
  );
};
const Login = (props) => {
  const ref = new URLSearchParams(useLocation().search)?.get("ref");
  const classes = useStyles(props);
  const { t } = useTranslation();
  return (
    <Grid
      container
      style={{
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        style={{
          display: "flex",
          textAlign: "center",
          justifyContent: "center",
          marginLeft: "2vw",
          marginRight: "2vw",
          marginTop: "5vh",
          minHeight: "50vh",
        }}
      >
        <Grid
          container
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            minHeight: "50vh",
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              minHeight: "10vh",
            }}
          >
            <Avatar className={classes.avatar}>
              <TwitterIcon />
            </Avatar>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Typography
              component="h1"
              variant="h5"
              style={{
                margin: "1vw",
                color: "#4C1B14",
              }}
            >
              {t("signin.signuplogin")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <form className={classes.form} noValidate>
              <Button
                variant="contained"
                color="primary"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  justifySelf: "center",
                  margin: "auto",
                }}
                className={(classes.submit, classes.button)}
                onClick={() => {
                  window.location.href = `${
                    process.env.REACT_APP_BACKEND_URL
                  }/user/login/twitter${ref ? `?ref=${ref}` : ""}`;
                }}
              >
                {t("signin.signuptwiiter")}
              </Button>
            </form>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{ minHeight: "20vh" }}>
        <Grid
          container
          style={{
            marginTop: "10vh",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid item sm={12} xs={12} md={12} lg={12}>
            {t("signin.contact")}
          </Grid>
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            style={{
              marginTop: "2vh",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <IconButton aria-label="Twitter" component="span">
              <Link
                href="https://twitter.com/HashtaggerHQ"
                target="_blank"
                rel="noopener"
                color="textPrimary"
              >
                <TwitterIcon />
              </Link>
            </IconButton>
            <IconButton aria-label="Telegram" component="span">
              <Link
                href="https://t.me/HashtaggerOfficial"
                target="_blank"
                rel="noopener"
                color="textPrimary"
              >
                <TelegramIcon />
              </Link>
            </IconButton>
            <IconButton aria-label="Medium" component="span">
              <Link
                href="https://medium.com/@HashtaggerHQ"
                target="_blank"
                rel="noopener"
                color="textPrimary"
              >
                <Icon icon={mediumIcon} style={{ fontSize: "1em" }} />
              </Link>
            </IconButton>
          </Grid>
          <Grid item sm={12} xs={12} md={12} lg={12}>
            <LanguageSelector />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default function SignInSide(props) {
  const classes = useStyles(props);
  const [open, setOpen] = React.useState(0);
  const { location } = props;
  const theme = useTheme();
  const { t } = useTranslation();

  const askido = new URLSearchParams(location?.search).get("asked");
  if (askido && !open) {
    setOpen(1);
  }

  const modal = (
    <Modal
      open={open === 1}
      onClose={() => setOpen(2)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{
        display: "flex",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ fontSize: "6vh", color: "#C0CBED" }}>
        {t("signin.thanks")}
      </div>
    </Modal>
  );

  const explanations = (
    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      style={{
        minHeight: "100vh",
        paddingTop: "4vh",
        backgroundColor: "#C0CBED",
      }}
    >
      <Grid
        container
        id="sec2"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h2
            style={{
              color: "#444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2600,
            }}
          >
            {t("signin.about")}
          </h2>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{
            minHeight: "30vh",
            minWidth: "20vw",
            marginLeft: "10vw",
            marginTop: "10vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            justifySelf: "center",
          }}
          className="bounce"
        >
          <Grid container style={{ display: "flex", justifyContent: "center" }}>
            <Grid
              item
              className={classes.image2}
              style={{
                minHeight: "30vh",
                minWidth: "20vw",
                backgroundColor: "#C0CBED",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          style={{
            minHeight: "60vh",
            minWidth: "20vw",
            marginLeft: "1vw",
            marginRight: "1vw",
            marginTop: "10vh",
          }}
        >
          <Grid
            container
            style={{
              minHeight: "60vh",
              marginRight: "1vw",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <TabSlides />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
  const NavDot = () => (
    <div id="dot-nav">
      <ul>
        <LinkScroll
          activeClass="active"
          to="sec1"
          smooth="true"
          spy
          offset={-90}
          duration={1100}
        >
          <li className="awesome-tooltip" title="Home" />
        </LinkScroll>
        <LinkScroll
          activeClass="active"
          to="sec2"
          smooth="true"
          spy
          offset={-90}
          duration={1100}
        >
          <li className="awesome-tooltip" title="About" />
        </LinkScroll>
        <LinkScroll
          activeClass="active"
          to="sec3"
          smooth="true"
          spy
          offset={-150}
          duration={1100}
        >
          <li className="awesome-tooltip" title="Projects" />
        </LinkScroll>
      </ul>
    </div>
  );
  const Animation = () => (
    <Grid
      container
      direction="column"
      alignItems="center"
      alignContent="stretch"
      justify="center"
    >
      <Slide direction="up" in timeout={2000}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <img
            alt="ballong"
            src="/imgs/htgballoonText.svg"
            style={{ width: "100%", height: "100%" }}
          />
        </Grid>
      </Slide>
      <Grid item xs={12} md={12} lg={12}>
        <h2
          style={{
            color: "#444",
          }}
        >
          {t("signin.getrewards")}
        </h2>
      </Grid>
      <Hidden xsDown>
        <Slide direction="down" in timeout={1200}>
          <Grid item xs={12} md={12} lg={12}>
            <ExpandMoreIcon style={{ fontSize: "80px" }} />
          </Grid>
        </Slide>
      </Hidden>
    </Grid>
  );
  const applyIDO = (
    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      style={{
        minHeight: "100vh",
        paddingTop: "4vh",
        backgroundColor: "#C0EDE3",
      }}
    >
      <Grid
        container
        id="sec3"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h2
            style={{
              color: "#444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {t("signin.next")}
          </h2>
        </Grid>

        <Grid
          item
          xs={7}
          sm={7}
          md={7}
          lg={7}
          className={classes.image3}
          style={{
            minHeight: "30vh",
            minWidth: "20vw",
            marginTop: "10vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            justifySelf: "center",
            backgroundColor: "#C0EDE3",
          }}
        />
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            paddingTop: "2vh",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            color="textSecondary"
            style={{
              paddingTop: "2vh",
            }}
          >
            {t("signin.availableon")}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          align="center"
          style={{
            paddingTop: "2vh",
          }}
        >
          <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            alignItems="center"
          >
            {[
              {
                logo: "/imgs/logos/pancakeswap.png",
                name: "Pancake Swap",
                url: "https://pancakeswap.finance/swap?outputCurrency=0xa0b9bb05da11e3b19ffd64554400f59d4a378515&inputCurrency=0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
                width: "300px",
              },
              {
                logo: "/imgs/logos/gateio.svg",
                name: "Gate.io",
                url: "https://www.gate.io/trade/MOOO_USDT",
                date: new Date("2021-12-10T02:00:00Z"),

                width: "140px",
              },
            ].map((e) => (
              <Grid item xs={12} sm={12} md={6} lg={4} key={e.name}>
                <Tooltip
                  onClick={() => {
                    if (e.url) {
                      window.open(e.url, "_blank", "noopener,noreferrer");
                    }
                  }}
                  title={t("signin.gotowebsite", { name: e.name })}
                >
                  <img alt={e.name} src={e.logo} style={{ width: e.width }} />
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          paddingTop: "2vh",
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography
            variant="h4"
            align="center"
            color="textSecondary"
            style={{
              paddingTop: "2vh",
            }}
          >
            {t("signin.ourinvestors")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          align="center"
          style={{
            paddingTop: "2vh",
          }}
        >
          <Grid
            container
            spacing={4}
            direction="row"
            justify="center"
            alignItems="center"
          >
            {[
              {
                logo: "/imgs/logos/ngc.png",
                name: "NGC",
                url: "https://www.ngc.fund/",
              },
              {
                logo: "/imgs/logos/cms.png",
                name: "CMS",
                url: "http://cmsholdings.io/",
              },
              {
                logo: "/imgs/logos/au21.png",
                name: "AU21",
                url: "https://au21.capital/",
              },
              {
                logo: "/imgs/logos/gbv.png",
                name: "Genesis Block Ventures",
                url: "https://gbv.capital/",
              },
              {
                logo: "/imgs/logos/microcosm.png",
                name: "Microcosm",
                url: "",
                width: "130px",
              },

              {
                logo: "/imgs/logos/basicscapital.png",
                name: "Basics capital",
                url: "https://www.basics.vip/",
                width: "160px",
              },
              {
                logo: "/imgs/logos/catchervc.png",
                name: "Catchervc",
                url: "https://catchervc.chaincatcher.com/",
              },
              {
                logo: "/imgs/logos/viabtc.png",
                name: "ViaBTC capital",
                url: "https://capital.viabtc.net/",
                width: "130px",
              },
              {
                logo: "/imgs/logos/m6.svg",
                name: "Momentum6",
                url: "https://momentum6.com/",
                width: "110px",
              },
              {
                logo: "/imgs/logos/dweb3.png",
                name: "DWeb3",
                url: "https://dweb3.io/",
              },
              {
                logo: "/imgs/logos/helloventures.png",
                name: "Hello capital",
                url: "https://hellocapital.fund/",
              },
              {
                logo: "/imgs/logos/chainflow.png",
                name: "Chainflow",
                url: "https://chainflow.io/",
              },
              {
                logo: "/imgs/logos/liquefy.png",
                name: "Liquefy",
                url: "https://liquefy.com/",
              },
              {
                logo: "/imgs/logos/sparkcapital.png",
                name: "Spark capital",
                url: "https://sparkdigitalcapital.com/",
              },
              {
                logo: "/imgs/logos/synaps.png",
                name: "Synaps",
                url: "https://synaps.io/",
              },
              {
                logo: "/imgs/logos/ampliocapital.png",
                name: "Amplio capital",
                url: "https://twitter.com/ampliocapital",
              },
              {
                logo: "/imgs/logos/duckdao.svg",
                name: "Duck dao",
                url: "https://duckdao.io/",
              },

              {
                logo: "/imgs/logos/gateio.labs.svg",
                name: "Gate",
                url: "https://www.gate.io/",
                width: "200px",
              },
            ].map((e) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={e.name}>
                <Tooltip
                  onClick={() => {
                    window.open(e.url, "_blank", "noopener,noreferrer");
                  }}
                  title={t("signin.gotowebsite", { name: e.name })}
                >
                  <img
                    alt={e.name}
                    src={e.logo}
                    style={{ width: e.width || "180px" }}
                  />
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
  return (
    <>
      {modal}
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid container>
          <ProgressPage />
          <Hidden xsDown>
            <NavDot />
          </Hidden>
          <Grid item xs={12} sm={9} md={9} lg={9}>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className="clouds"
                id="sec1"
                style={{
                  backgroundImage: `url("/imgs/cloudbg.webp")`,
                  backgroundColor: "#BFDFEC",
                  padding: "5em",
                }}
              >
                <Animation />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  padding: "3vh",
                  backgroundImage:
                    "linear-gradient(rgba(191, 223, 236, 1),#C0CBED,#C0CBED)",
                }}
              />
              {explanations}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  padding: "3vh",
                  backgroundImage: "linear-gradient(#C0CBED ,#C0EDE3,#C0EDE3",
                }}
              />
              {applyIDO}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  padding: "3vh",
                  backgroundImage: `linear-gradient(#C0EDE3 ,${theme.palette.secondary.main}`,
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            id="sec4"
            xs={12}
            sm={3}
            md={3}
            lg={3}
            component={Paper}
            elevation={16}
            square
            style={{
              ...(useMediaQuery(theme.breakpoints.up("sm"))
                ? { position: "fixed" }
                : {}),
              alignItems: "center",
              justifyItems: "center",
              justifySelf: "center",
              right: "0px",
              backgroundColor: theme.palette.secondary.main,
            }}
          >
            {Login(props)}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
